// ----------------------------------------------------------------------

import { createClasses } from 'src/utils/create-classes';

export const scrollbarClasses = {
  root: createClasses('scrollbar__root'),
};
